import clarity from '@microsoft/clarity'
import { appConfig } from './config'

if (appConfig.environment === 'development' || appConfig.environment === 'vitest') {
  // eslint-disable-next-line no-console
  console.log('Not initializing Clarity in this environment: ', appConfig.environment)
} else if (appConfig.clarity.projectId !== 'not configured') {
  clarity.init(appConfig.clarity.projectId)
}
